<div class="card" (click)="openMap()">
  <div [ngStyle]="{ 'background-image': getBackground(page.image) }" class="widget-image"></div>
  <div class="card-content" [ngStyle]="setStyle()">
    <h4 class="title" [ngClass]="{'largeLabels': page.largeLabels}">
      <i class="material-icons icon" *ngIf="page.icon">{{page.icon | i18n}}</i> {{page.title | i18n}}</h4>
  </div>
</div>
